// A simple event bus for displaying notifications and stuff.
// Sometimes vuex doesn't match the purpose.
import Vue from 'vue'
export default new Vue()
